import React from 'react';
import Icon from '../Icon/Icon';
import Link from '../Link/Link';
import Flex from '../Flex/Flex';

function DownloadIcon({ url }) {
  return (
    <Link openInNewWindow to={url}>
      <Flex centeredVertically>
        <Icon name="download" size="sm" clickableAppearance />
      </Flex>
    </Link>
  );
}

export default DownloadIcon;
